import { StateProps } from "@tagged-state/core";
import { ContractReceipt, ContractTransaction } from "ethers";
import { State as LoginInfoState } from "./api/getLoginInfo/state";
import { State as PaymentInfoState } from "./api/getPaymentInfo/state";

type Item = "login_challenge";

export type LoginChallengeData = {
  paymentInfo: StateProps<PaymentInfoState>["ready"];
  loginInfoFull: StateProps<LoginInfoState>["full"];
  alreadyPaid: boolean;
  contractTransaction: ContractTransaction;
  contractReceipt: ContractReceipt;
};
type LocalStorageDataMap = Record<string, Partial<LoginChallengeData>>;

type LocalStorageData<I extends Item> = I extends "login_challenge"
  ? LocalStorageDataMap
  : never;

const getItem = <I extends Item>(
  item: I,
  loginChallenge: string,
): Partial<LoginChallengeData> | null => {
  const data = localStorage.getItem(item);
  const loginChallengeData = data
    ? (JSON.parse(data) as LocalStorageData<I>)
    : null;

  if (loginChallengeData === null) {
    return null;
  }

  return loginChallengeData[loginChallenge];
};

const setItem = <I extends Item>(
  item: I,
  loginChallenge: string,
  value: Partial<LoginChallengeData>,
): Partial<LoginChallengeData> => {
  const data = localStorage.getItem(item);
  const loginChallengeData = data
    ? (JSON.parse(data) as LocalStorageDataMap)
    : {};

  const currentChallengeData = {
    ...loginChallengeData[loginChallenge],
    ...value,
  };

  loginChallengeData[loginChallenge] = currentChallengeData;

  localStorage.setItem(item, JSON.stringify(loginChallengeData));

  return currentChallengeData;
};

const typedLocalStorage = {
  getItem,
  setItem,
};

export default typedLocalStorage;
